export default class ApiEventController {
    static EVENTS = {
        'UPDATE_CART': 'searchbooster.updateCart',
        'UPDATE_FAVOURITES': 'searchbooster.updateFavourites',
    }

    static pushEvent(event, data) {
        const eventName = ApiEventController.EVENTS[event];

        if (!eventName) {
            throw new Error(`Invalid api event: ${event}`);
        }

        window.dispatchEvent(new CustomEvent(eventName, { detail: data }));
    }

    static on(event, callback) {
        window.addEventListener(event, callback);
    }
}
